import {
	AfterViewChecked,
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	Inject,
	OnInit,
	Optional,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractRates, RailroadRegularTimeBasis } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { takeUntil, filter } from 'rxjs/operators';
import { contractRatesFormConfig } from '../contract-rates.component';

@Component({
	selector: 'rpshared-contract-rates-dialog',
	templateUrl: './contract-rates-dialog.component.html',
})
export class ContractRatesDialogComponent
	extends SelfDestruct
	implements OnInit, AfterViewInit, AfterViewChecked
{
	control = new FormControl('') as FormControl;

	group = this.fb.group(contractRatesFormConfig) as FormGroup;
	isReadonly: boolean;

	constructor(
		private readonly changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		readonly data: {
			contractRates: ContractRates;
			readonly: boolean;
			railroadRegularTimeBasis: RailroadRegularTimeBasis;
			isApplyPrevailingWage: boolean;
		},
		private readonly fb: FormBuilder
	) {
		super();
		if (this.data) {
			this.isReadonly = data.readonly;
		}
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.data && this.data.contractRates) {
			let contractedRates = this.data.contractRates;
			if (this.data.isApplyPrevailingWage) {
				contractedRates.isPayrollFeeWeekly = true;
			}
			this.control.setValue(contractedRates, { emitEvent: true });
		}

		if (this.isReadonly) {
			this.control.disable();
		}
	}

	ngAfterViewInit() {
		if (this.data && this.data.contractRates) {
			this.control.updateValueAndValidity();
		}
	}
	ngAfterViewChecked(): void {
		this.changeDetectorRef.detectChanges();
	}
}
